import { GOOGLE_SIGNIN_URL, USER_PERMISSIONS, USER_ROLE_URL } from '../../utils/apiEndpoints';
import { AUTHENTICATION_TOKEN, REFRESH_TOKEN } from '../../constants/common';
import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit';
import { Notification } from '../../components/Notification';
import { mapUserPermission } from '../../utils/common';
import { setToken } from '../../utils/cookie';
import clientService from '../../apiClient';
import { templates } from '../../utils/templates';

const initialState = {
  loading: false,
  user: null,
  authSucess: false,
  authError: false,
  userOrganizationId: null,
  userRoles: null,
  userPermissionMap: {},
  userPermissions: {},
  preferredAiLanguage: 'english',
  // templateList: templates,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    logout: (state) => {
      return { ...state, user: null };
    },
    updateUserOrganizationIdInLocalStorage: (state, action) => {
      state.userOrganizationId = action?.payload;
    },
    authenticateUser: (state, action) => {
      state.loading = false;

      setToken(AUTHENTICATION_TOKEN, action?.payload?.access_token, 1);
      setToken(REFRESH_TOKEN, action?.payload?.refresh_token, 7);

      state.user = action?.payload?.user;
    },
    changeAiLanguage: (state, action) => {
      const value = action.payload?.responseLanguage;
      state.preferredAiLanguage = value;
    },
    addTemplate: (state, action) => {
      state.templateList.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserRoles.fulfilled, (state, action) => {
      state.userRoles = action.payload.data;
      state.loading = false;
    });

    builder.addCase(getUserRoles.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUserRoles.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(fetchUserPermissions.fulfilled, (state, action) => {
      state.loading = false;
      state.userPermissionMap = mapUserPermission(action?.payload);
    });
    builder.addCase(fetchUserPermissions.rejected, (state, action) => {
      state.loading = false;
      state.userPermissionMap = {};

      Notification.error('Something went wrong', action?.payload.error);
    });
    builder.addCase(getUserDetails.fulfilled, (state, action) => {
      state.userPermissions = action.payload;
    });
  },
});

export const googleLogin = createAsyncThunk('user/googleLogin', async (oAuthCode) => {
  const res = await clientService.post(GOOGLE_SIGNIN_URL, {
    code: oAuthCode,
  });
  return res;
});

export const fetchUserPermissions = createAsyncThunk(
  'user/fetcguserpermissions',
  async (params, { rejectWithValue }) => {
    try {
      const response = await clientService.get(`${USER_PERMISSIONS}/workspaces`, { params });

      return response?.data;
    } catch (err) {
      return rejectWithValue({ error: err?.data?.error?.message });
    }
  }
);

export const getUserRoles = createAsyncThunk('user/getUserRoles', async (params) => {
  const res = await clientService.get(USER_ROLE_URL, {
    params,
  });

  return res;
});
export const getUserDetails = createAsyncThunk('user/getuserdetails', async (params, { rejectWithValue }) => {
  try {
    const response = await clientService.get(`${USER_PERMISSIONS}/user`, { params });

    return response?.data;
  } catch (err) {
    return rejectWithValue({ error: err?.data?.error?.message });
  }
});

export default userSlice.reducer;
export const { logout, updateUserOrganizationIdInLocalStorage, authenticateUser, changeAiLanguage } = userSlice.actions;
